import { Common, ApiBind } from './common.model';
import { TesterValue } from './tester-value.model';

export class TesterDevice extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'adid' })
  adid: string;

  @ApiBind({ column: 'debug_mode' })
  debugMode: number;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  @ApiBind({ column: 'testers', model: (values) => values.map(value => new TesterValue(value)) })
  testerValues: TesterValue[];

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }

}
